import  gql  from 'graphql-tag'

export const regionals = gql`query Regionals($isActive: Boolean){ 
    regionals(isActive:$isActive){
            edges{
                node{
                    id,
                    code,
                    name,
                    isActive
                }
            }
        }
    }`;
